import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getResidueCategoryList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditResidueCategoryModal from './Add_Edit/AddEditResidueCategoryModal';
import DeleteResidueCategory from './Delete/DeleteResidueCategory';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const ResidueCategoriesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorResidueCategories = createSelector(
		state => state.ResidueCategories,
		residueCategory => ({
			residueCategoryList: residueCategory.residueCategoryList,
			isLoadingList: residueCategory.isLoadingList,
			isResidueCategorySuccess: residueCategory.isResidueCategorySuccess,
			error: residueCategory.error,
			isAdding: residueCategory.isAdding,
			isAdded: residueCategory.isAdded,
			isAddError: residueCategory.isAddError,
			isUpdating: residueCategory.isUpdating,
			isUpdated: residueCategory.isUpdated,
			isUpdateError: residueCategory.isUpdateError,
			isDeleting: residueCategory.isDeleting,
			isDeleted: residueCategory.isDeleted,
			isDeleteError: residueCategory.isDeleteError,
		})
	);

	const { residueCategoryList, isLoadingList } = useSelector(
		selectorResidueCategories
	);

	useEffect(() => {
		dispatch(getResidueCategoryList());
	}, []);

	const [dataResidueCategory, setDataResidueCategory] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete ResidueCategory
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = residueCategory => {
		setDataResidueCategory(residueCategory);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = residueCategory => {
		setDataResidueCategory(residueCategory);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'residueCategory',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const residueCategoryData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(residueCategoryData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const residueCategoryData =
														cellProps.row.original;
													handleClickDelete(residueCategoryData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{
				header: 'Tipo',
				accessorKey: 'residue_type.name',
				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className="border-0 pb-0">
							<div className="d-flex align-items-end justify-content-end">
								<div className="flex-shrink-0">
									<div className="d-flex flex-wrap gap-2">
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataResidueCategory({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Categoría de Residuo
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<div className='card-body pt-3'>
							<ODataGrid
								columns={columns}
								data={residueCategoryList || []}
								isLoadingData={isLoadingList}
								nameFile={'categoria_de_residuos'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataResidueCategory({});
											handleToggleModal();
										},
										title: 'Crear Categoría de Residuo',
									}
								]}
							/>
						</div>
					</Card>
				</Col>
			</Row>

			<AddEditResidueCategoryModal
				dataResidueCategory={dataResidueCategory}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteResidueCategory
				dataResidueCategory={dataResidueCategory}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ResidueCategoriesList;
